<template>
  <div
    v-if="showed"
    id="paypal-button"
    :class="{
      'disabled-payment': disabled,
    }"
  />
</template>

<script>
import paymentMixin from "./payment-mixin";
import { loadScript } from "@paypal/paypal-js";
import moment from "moment";

export default {
  name: "PayPal",
  mixins: [paymentMixin],
  data: () => ({
    style: {
      size: "responsive",
      shape: "rect",
      height: 55,
      label: "paypal",
      color: "white",
      tagline: false,
    },
    experienceOptions: {
      input_fields: {
        no_shipping: 1,
      },
    },
    clicksCounter: 0,
  }),
  async created() {
    if (!this.showed) return;
    const self = this;
    loadScript({
      "client-id": process.env.VUE_APP_PAYPAL_CLIENT_ID,
      "disable-funding":
        "card,credit,paylater,bancontact,blik,eps,giropay,ideal,mercadopago,mybank,p24,sepa,sofort,venmo",
      currency: this.currency,
    })
      .then((paypal) => {
        paypal
          .Buttons({
            style: this.style,
            createOrder: (data, actions) => {
              this.clicksCounter++;
              if (this.clicksCounter === 3) {
                this.$amplitude.logEvent(`Paypal button clicked 3+ times`, {
                  qrCode: this.qrCodes.join(","),
                  amount: this.amount,
                  clientPaysFee: !!this.clientPaysFee,
                });
              }

              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      value: self.amount / 100,
                    },
                    description: `${this.$t("pay.tips-for")} ${
                      this.business.name
                    } ${moment(
                      new Date(),
                      "DD MMM YYYY, LT",
                      this.$i18n.locale
                    ).format("DD MMM YYYY, LT")}`,
                  },
                ],
              });
            },
            onApprove: self.completePayPal,
            onError: (err) => {
              this.$amplitude.logEvent(`Paypal payment error`, {
                qrCode: this.qrCodes.join(","),
                amount: this.amount,
                clientPaysFee: !!this.clientPaysFee,
                payload: err,
              });
              console.error("error", err);
            },
            onCancel: (data) => {
              this.$amplitude.logEvent(`Paypal payment cancelled`, {
                qrCode: this.qrCodes.join(","),
                amount: this.amount,
                clientPaysFee: !!this.clientPaysFee,
                payload: data,
              });
              // console.log("canceled", data);
            },
          })
          .render("#paypal-button")
          .then(() => {
            this.$emit("paypal-rendered", true);
          })
          .catch((error) => {
            console.error("failed to render the PayPal Buttons", error);
            this.$emit("paypal-rendered", false);
          });
      })
      .catch((error) => {
        console.error("failed to load the PayPal JS SDK script", error);
      });
  },
  methods: {
    sendLogs() {
      this.$amplitude.logEvent(`Payment page event PayPal button clicked`, {
        qrCode: this.qrCode,
      });
    },
    async completePayPal(data) {
      const params = {
        qrCodes: this.paymentObject,
        clientPaysFee: !!this.clientPaysFee,
        amount: this.amount,
        currency: this.currency,
      };

      this.sendLogs();

      await this.$axios
        .post("/api/v1/tx-paypal", Object.assign(params, data))
        .then((response) => {
          if (response.data?.payload?.txId) {
            this.$router.push({
              name: "Receipt",
              params: { transactionId: response.data.payload.txId },
            });
          } else {
            this.$message.error(this.$t("form.something-wrong"));
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.paypal-button::v-deep {
  .zoid-visible {
    z-index: 10 !important;
  }
}

#paypal-button {
  z-index: 1;
  position: relative;
  margin: 12px auto 0 auto;
}
</style>
